import React, { useRef, useEffect } from 'react';

interface SimpleAudioProps {
  url?: string;
  playing: boolean;
}

const SimpleAudio: React.FC<SimpleAudioProps> = ({ url, playing }) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (!audioRef.current || !url) return;

    console.log('🔊 SimpleAudio: URL modtaget:', url);
    
    // Reset audio element når URL ændres
    audioRef.current.load();
    
    const audio = audioRef.current;
    
    const handleLoadStart = () => console.log('🔊 SimpleAudio: Starter indlæsning');
    const handleLoadedData = () => console.log('🔊 SimpleAudio: Data indlæst');
    const handleCanPlay = () => console.log('🔊 SimpleAudio: Klar til afspilning');
    const handleError = (e: Event) => {
      console.error('🔊 SimpleAudio: Fejl:', e);
      if (audio.error) {
        console.error('🔊 SimpleAudio: Error code:', audio.error.code);
        console.error('🔊 SimpleAudio: Error message:', audio.error.message);
      }
    };

    audio.addEventListener('loadstart', handleLoadStart);
    audio.addEventListener('loadeddata', handleLoadedData);
    audio.addEventListener('canplay', handleCanPlay);
    audio.addEventListener('error', handleError);

    return () => {
      audio.removeEventListener('loadstart', handleLoadStart);
      audio.removeEventListener('loadeddata', handleLoadedData);
      audio.removeEventListener('canplay', handleCanPlay);
      audio.removeEventListener('error', handleError);
    };
  }, [url]);

  useEffect(() => {
    if (!audioRef.current || !url) return;

    const audio = audioRef.current;

    if (playing) {
      console.log('🔊 SimpleAudio: Starter afspilning');
      audio.play().catch(error => {
        console.error('🔊 SimpleAudio: Afspilningsfejl:', error);
      });
    } else {
      console.log('🔊 SimpleAudio: Stopper afspilning');
      audio.pause();
      audio.currentTime = 0; // Reset til start
    }
  }, [playing, url]);

  if (!url) {
    return (
      <span style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
        Ingen lydfil tilgængelig
      </span>
    );
  }

  return (
    <>
      <audio ref={audioRef} src={url} preload="metadata" />
      <span style={{ fontSize: '12px', color: '#666' }}>
        {playing ? '🔊 Afspiller...' : '🎵 Klar til afspilning'}
      </span>
    </>
  );
};

export default SimpleAudio; 